export const isHomePage = () => (window.location.pathname === "/")